import { FilterDefinitionDTO } from "../DTO/filterDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class CreateFilterDefinitionRequest extends BasicRequest{
   
    public filterDefinition! : FilterDefinitionDTO;
    
    constructor(){
        super();
    }
}